import SiteHeader from "./site-header";
import SiteNavMobile from "./site-nav-mobile";

export default () => {
    function init() {
        jQuery(document).on('click', 'a[href*="#"]', function (event) {
            const href = jQuery(this).attr('href');

            if (!href || href === '#') {
                return;
            }

            const url = new URL(href, window.location.href);
            const currentUrl = new URL(window.location.href);

            const isSamePage =
                url.origin === currentUrl.origin &&
                url.pathname.replace(/\/$/, '') === currentUrl.pathname.replace(/\/$/, '');

            // If link points to another page, let browser navigate normally
            if (!isSamePage) {
                return;
            }

            const hash = url.hash;

            if (hash && jQuery(hash).length) {
                event.preventDefault();

                const target = jQuery(hash).offset().top - SiteHeader().getHeight();

                jQuery("html, body").animate(
                    { scrollTop: target },
                    "slow",
                    "swing"
                );

                if (jQuery(SiteNavMobile().nodeSelectors.container).is(':visible')) {
                    SiteNavMobile().close();
                }
            }
        });
    }

    return Object.freeze({
        init,
    });
};